import React from "react";
import { useTranslation } from "react-i18next";
import { WeekRing } from "./WeekRing";
import { WeekDays } from "./WeekDays";
import { BadgeToken } from "./BadgeToken";
import { BigCheckIcon, MailIcon } from "./icons";
import "./gamification.css";

/**
 * The screen after a session is saved — where the app used to show an
 * alert(). The ring for this week, the seven days, the streak once it is
 * more than one week, any badge the session just earned, and one button.
 * `outcome` comes from sessionOutcome().
 */
export function SessionComplete({ outcome, programName, onDone }) {
  const { t } = useTranslation();
  const { week, streak, milestones, newBadges } = outcome;

  return (
    <div className="gm gm-complete">
      <div className="gm-complete-hero">
        <WeekRing done={week.done} goal={week.goal} size={152} stroke={12} label={t("gamification.week.units")}>
          {week.complete ? <BigCheckIcon className="gm-ring-check" /> : null}
        </WeekRing>
        <h3>{t(week.complete ? "gamification.complete.title_week" : "gamification.complete.title_saved")}</h3>
        <p>
          {programName} · {t("gamification.complete.session", { done: milestones.done, planned: milestones.planned })}
          <br />
          {t("gamification.complete.week", { done: week.done, goal: week.goal })}
        </p>
      </div>

      <WeekDays days={week.days} center />

      {week.complete && streak >= 2 && (
        <p className="gm-complete-streak">{t("gamification.complete.streak", { count: streak })}</p>
      )}

      {newBadges.map((badge) => (
        <div key={badge.id} className="gm-card gm-tile">
          <BadgeToken id={badge.id} />
          <div className="gm-tile-body">
            <span className="gm-tile-label">{t("gamification.complete.new_badge")}</span>
            <span className="gm-tile-name">{t(`gamification.badges.${badge.id}.name`)}</span>
            <span className="gm-tile-note">{t(`gamification.badges.${badge.id}.criterion`)}</span>
          </div>
        </div>
      ))}

      <p className="gm-hint gm-hint-boxed">
        <MailIcon />
        {t("gamification.complete.therapist")}
      </p>

      <button type="button" className="sophy-ps-btn sophy-ps-btn-primary" onClick={onDone}>
        {t("gamification.complete.done")}
      </button>
    </div>
  );
}

export default SessionComplete;
